import { createAction } from 'redux-starter-kit';

/**
 * An action that signifies model types should be replaced with new data.
 * @example dispatch(putModelTypes(modelTypes))
 */
export const putModelTypes = createAction('PUT_MODEL_TYPES');

/**
 * An action that signifies a model type should be replaced with new data.
 * @example dispatch(putModelType(modelType))
 */
export const putModelType = createAction('PUT_MODEL_TYPE');
